import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Agency } from 'model/agency';
import { put, get } from 'store/request';

export const fetchAgencyDetail = createAsyncThunk('agency/getAgencyDetail', () => get('/agency/get_agency_detail'));

export const updateAgencyDetail = createAsyncThunk('agency/updateAgencyDetail', async (params: Agency) =>
  put('/agency/update_agency_detail', params)
);

interface AgencyState {
  agencyDetail: Agency;
  agencyDetailLoading: boolean;
}

const initialState: AgencyState = {
  agencyDetail: {},
  agencyDetailLoading: false,
};

const agencySlice = createSlice({
  name: 'agency',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAgencyDetail.pending, (state) => {
      state.agencyDetailLoading = true;
    });
    builder.addCase(fetchAgencyDetail.fulfilled, (state, { payload }: PayloadAction<Agency>) => {
      state.agencyDetail = payload;
      state.agencyDetailLoading = false;
    });
    builder.addCase(fetchAgencyDetail.rejected, (state) => {
      state.agencyDetailLoading = false;
    });
    builder.addCase(updateAgencyDetail.pending, (state) => {
      state.agencyDetailLoading = true;
    });
    builder.addCase(updateAgencyDetail.fulfilled, (state) => {
      state.agencyDetailLoading = false;
    });
    builder.addCase(updateAgencyDetail.rejected, (state) => {
      state.agencyDetailLoading = false;
    });
  },
});

export default agencySlice;
